export default {"src":"/_next/static/media/tech-integration.160ac22b.svg","height":686,"width":686,"blurWidth":0,"blurHeight":0};